import { connect } from 'react-redux';
import { login } from 'data/login/login.actions';
import LoginContainer from './LoginContainer';

const actions = {
  login
};

function mapStateToProps(state) {
  return {
    ...state.login
  };
}

export default connect(mapStateToProps, actions)(LoginContainer);
